import Request from "./Request";
import store from "../state-management";
import { Authenticate as AuthenticateService } from "./Authenticate";
import { setUser } from "../state-management/user/user.reducer";

export const isUndefined = (item: string | null) => !item || item === "undefined";

export class Token {

  public static checkJWTValidityFromAPI() {
    Request.checkJWT().then((response) => {
      store.dispatch(setUser({
        isLogged: true,
        data: response.data
      }));
    }).catch((error) => { 
        // If authentication failed (401) and refresh failed, redirect to login
        if (error.response && error.response.status === 401) {
             AuthenticateService.login();
        }
    });
  }

  public static async refreshToken() {
    return await Request.refreshToken().then((resf: any) => {
       // Cookies are updated by backend response headers
       this.updateUserLoggedStatus();
       return true;
    }).catch((e) => { 
        console.error("cannot refresh token", e); 
        AuthenticateService.login();
        return Promise.reject(e);
    });
  }

  private static updateUserLoggedStatus() {
    store.dispatch(setUser({
      isLogged: true
    }));
  }
}
